const root = "Layout-module_root_qzPL-fKI";
const banner = "Layout-module_banner_-ouynTI9";
const main = "Layout-module_main_M31JNT3u";
const styles = {
  root,
  banner,
  main
};
export {
  banner,
  styles as default,
  main,
  root
};
